import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Card, Col, Input, Label, Row } from 'reactstrap'
import { useReportCxc } from '../../../hooks/reports/useReportCxc'
import './styleReport.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Dialog } from 'primereact/dialog';
import reportCxcCompanyAltImage from '../../../assets/images/price/company-Ban.svg'
import { Badge } from 'primereact/badge';
import { Tag } from 'primereact/tag';
import { DataView } from 'primereact/dataview';
import Select from 'react-select';
import { useModal as useMorphingModal } from "react-morphing-modal";
import { useHistory } from 'react-router-dom';
import { Chart } from 'primereact/chart';





export const IndexReportCxc = () => {

    const {
        loadingTotalIngress, loadingTableClients, lblTotalIngress, lblOutSideBalance, lblTotalClients,
        detailTransactionsByClients, listDetailTransactionsByClients,
        handleFilterByClient, handleFilterDate, number_format,
        handleCleanFilterByClient,

        // * FILTERS
        filterCredit, setFilterCredit,
        filterAccount, setFilterAccount,
        filterPayment, setFilterPayment,
        filterPendingPayment, setFilterPendingPayment,
        filterInvoiced, setFilterInvoiced,
        filterPendigInvoiced, setFilterPendigInvoiced,
        filterPreInvoice, setFilterPreInvoice,

        //* DOWNLOAD REPORT CXC
        DownloadReportCxc,

        // ? FILTER PAYMETHODS
        filterAmountCredit, setFilterAmountCredit,
        filterAmountDebit, setFilterAmountDebit,
        filterAmountTcredit, setFilterAmountTcredit,
        filterAmountTrasferencia, setFilterAmountTrasferencia,
        filterAmount, setFilterAmount,

        lblTotalPaidIngress, lblTotalPatient, loadingIdR,
        setDateStart, setDateEnd, dateStart, dateEnd, companyInfo,
        getBadgeStatus, dataViewCompany,
        listAgreement, valuId, handleChangeAgreement, filterId,
        loadingView2, loadingView1

        // ? SEARCH AGREEMENTS
        , searchQuery, handleSearchChange, setsearchView1,

        // ? CONFIGURATION CHART GLOBAL
        options, selectedCompany, visible, setVisible,

        // ? CONFIGURATION FILTER DATA TABLE
        rowExpansionTemplate, filteredData, calculatePaymentMethod, getstatusInvoice, getValueTax, tagInfo,
        getTransactionLabel, filteredClients,

        expandedRows, setExpandedRows, expandedRows2, setExpandedRows2,
        globalFilter, globalFilter2, setGlobalFilter2,
        nameCompany, setNameCompany,
        searchQuerys, setSearchQuerys

    } = useReportCxc();
    console.log("🚀 ~ IndexReportCxc ~ filteredClients:", filteredClients)




    // * STYLES DATA TABLE
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2
    };

    // * VIEW DATA TABLE
    const viewDataTable = () => {
        return (
            <div>
                <DataTable
                    value={detailTransactionsByClients}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    loading={loadingTableClients}
                    className="data-table"
                    responsiveLayout="scroll"
                    emptyMessage={
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "45%" }}
                                alt="Sin resultados"
                            />
                            <br />
                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                No hay coincidencias con la búsqueda.
                            </p>
                        </div>
                    }
                    style={{ fontSize: "8px" }}
                    globalFilter={globalFilter}
                    header={
                        <Col sm="12" className='p-l-0 p-r-0'>
                            <Row>
                                <Col sm="11">
                                    <label className='f-w-700 label-dashboard' style={{ color: "#0d3b59", fontSize: "16px" }}>Busqueda avanzada</label>
                                </Col>
                                <Col sm="12">
                                    <Row className="align-items-center mt-2">
                                        <Col sm="6">
                                            <Label className='label-dashboard' style={{ color: "#0d3b59", fontSize: "14px" }}>Inicio</Label>
                                            <Input
                                                type="date"
                                                value={dateStart}
                                                onChange={(e) => setDateStart(e.target.value)}
                                                className="mr-2"
                                            />
                                        </Col>
                                        <Col sm="6">
                                            <Label className='label-dashboard' style={{ color: "#0d3b59", fontSize: "14px" }}>Fin</Label>
                                            <Input
                                                type="date"
                                                value={dateEnd}
                                                onChange={(e) => setDateEnd(e.target.value)}
                                                className="mr-2"
                                            />
                                        </Col>

                                    </Row>
                                </Col>
                                <Col sm="11" className='pt-3' >
                                    <div className='form-group'>
                                        <Label className='label-dashboard' style={{ color: "#0d3b59", fontSize: "14px" }}>Convenio</Label>
                                        <Select
                                            className="input-air-primary input-xs"
                                            classNamePrefix="select"
                                            name="client_id"
                                            value={valuId}
                                            options={listAgreement}
                                            placeholder="Seleccione un convenio"
                                            isClearable={true}
                                            onChange={(e) => handleChangeAgreement(e)}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    fontSize: '16px',
                                                    fontWeight: 'normal',
                                                }),
                                                option: (provided) => ({
                                                    ...provided,
                                                    fontSize: '16px',
                                                    fontWeight: 'normal',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    fontSize: '16px',
                                                    fontWeight: 'normal',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    fontSize: '16px',
                                                    fontWeight: 'normal',
                                                }),
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col sm="1" className="p-l-0 p-r-0 pt-5">
                                    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                        <Button
                                            icon="pi pi-search"
                                            rounded
                                            title='Busqueda global'
                                            severity="warning"
                                            aria-label="Search"
                                            onClick={() => handleFilterByClient(filterId, true)}
                                            style={{
                                                padding: "5px 10px",
                                                height: "35px",
                                                width: "35px",
                                                fontSize: "1rem",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    }
                />
            </div>
        );
    }

    // * ITEM TEMPLATE DATAVIEW
    const itemTemplate = (client) => {
        setNameCompany(client.name_client);

        return (
            <div className="client-card">
                {/* HEADER */}
                <div className="client-card-header">
                    <div>

                        <h6 className="client-name">
                            {client?.name_client ?? "---"}
                        </h6>

                        <small className="text-muted">
                            RFC: {client?.rfc_company ?? "---"}
                        </small>
                    </div>

                    <div className="client-actions">
                        {/* Excel */}
                        <button
                            onClick={() => DownloadReportCxc(client?.id_client)}
                            title={`Descargar reporte de: ${client?.name_client}`}
                            className="icon-btn"
                            disabled={loadingIdR === client?.id_client}
                        >
                            {loadingIdR === client?.id_client ? (
                                <i className="pi pi-spin pi-spinner text-success"></i>
                            ) : (
                                <i className="pi pi-file-excel text-success"></i>
                            )}
                        </button>

                        {/* Ver */}
                        {!dataViewCompany && (
                            <button
                                onClick={() =>
                                    handleFilterByClient(client?.id_client, false, false, true)
                                }
                                title={`Detalle de la empresa: ${client?.name_client}`}
                                className="icon-btn"
                                disabled={loadingIdR === client?.id_client}
                            >
                                {loadingIdR === client?.id_client ? (
                                    <i className="pi pi-spin pi-spinner text-primary"></i>
                                ) : (
                                    <i className="pi pi-eye text-primary"></i>
                                )}
                            </button>
                        )}
                    </div>
                </div>

                {/* BUSINESS NAME */}
                {client?.business_name && (
                    <div className="client-business">
                        {client.business_name}
                    </div>
                )}

                {/* TOTALS */}
                <div className="client-totals">
                    <Col sm="12" className='p-l-0 p-r-0' >
                        <Row>
                            <Col sm="4" className='total-item' >
                                <span>Total Crédito</span>
                                <strong className='txt-danger' >${client?.totalCredit?.toFixed(2) ?? "0.00"}</strong>
                            </Col>
                            <Col sm="4" className='total-item'>
                                <span>Total Pagado</span>
                                <strong className='txt-secondary' >${client?.totalPaid?.toFixed(2) ?? "0.00"}</strong>
                            </Col>
                            <Col sm="4" className='total-item'>
                                <span>Total Contado</span>
                                <strong className='txt-success' >${client?.totalCash?.toFixed(2) ?? "0.00"}</strong>
                            </Col>
                        </Row>
                    </Col>


                </div>

                {/* FOOTER */}
                <div className="client-card-footer">
                    {
                        client.active_agreement === false && <div
                            style={{
                                color: "#856404",
                                fontSize: "0.78rem",
                                marginTop: "6px",
                                fontWeight: "500",
                                backgroundColor: "#fff3cd",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                border: "1px solid #ffeeba",
                            }}
                        >
                            <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                            {"Convenio eliminado." ?? "---"}
                        </div>
                    }

                    {setsearchView1 && (
                        <Tag
                            icon="pi pi-eye"
                            value="Regresar"
                            onClick={handleCleanFilterByClient}
                            severity="danger"
                            className="pointer"
                        />
                    )}

                    {!setsearchView1 && client?.value_agreement > 2 && (
                        <Tag
                            icon="pi pi-eye"
                            value={dataViewCompany ? "Regresar" : "Ver Detalles"}
                            onClick={() =>
                                dataViewCompany
                                    ? handleCleanFilterByClient()
                                    : handleFilterByClient(client?.id_client, true, true)
                            }
                            severity={dataViewCompany ? "danger" : "primary"}
                            className="pointer tag-low-z"
                        />
                    )}
                </div>
            </div >
        );
    };







    const [search, setSearch] = useState("");






    // ? CONFIGURATION AGRUPED 
    const groupedByCompany = Object.values(
        listDetailTransactionsByClients.reduce((acc, item) => {
            const key = item.idClient;

            if (!acc[key]) {
                acc[key] = {
                    idClient: item.idClient,
                    nameClient: item.nameClient,
                    rows: []
                };
            }

            acc[key].rows.push(item);
            return acc;
        }, {})
    );

    const getCompanyTotal = (rows) => {
        const byWorkOrder = {};

        rows.forEach(r => {
            if (!byWorkOrder[r.idWorkOrder]) {
                byWorkOrder[r.idWorkOrder] =
                    (r.totalWorkOrder ?? 0) + (r.totalTax ?? 0);
            }
        });

        return Object.values(byWorkOrder).reduce((a, b) => a + b, 0);
    };

    const getAgreements = (rows) => {
        return Object.values(
            rows.reduce((acc, r) => {
                const key = r.nameAgreement ?? "Sin convenio";

                if (!acc[key]) {
                    acc[key] = {
                        nameAgreement: key,
                        total: 0
                    };
                }

                acc[key].total += (r.totalWorkOrder ?? 0) + (r.totalTax ?? 0);
                return acc;
            }, {})
        );
    };

    const [expandedCompany, setExpandedCompany] = useState(null);

    const toggleCompany = (id) => {
        setExpandedCompany(prev => (prev === id ? null : id));
    };


    const filteredCompanies = groupedByCompany.filter(company => {
        if (!search) return true;

        const searchText = search.toLowerCase();

        const clientMatch = company.nameClient
            ?.toLowerCase()
            .includes(searchText);

        const agreements = getAgreements(company.rows);
        const agreementMatch = agreements.some(ag =>
            ag.nameAgreement
                ?.toLowerCase()
                .includes(searchText)
        );

        return clientMatch || agreementMatch;
    });


    const top5Companies = [...groupedByCompany]
        .map(company => ({
            name: company.nameClient,
            total: getCompanyTotal(company.rows)
        }))
        .sort((a, b) => b.total - a.total)
        .slice(0, 5);


    const chartData = {
        labels: top5Companies.map(c => c.name),
        datasets: [
            {
                data: top5Companies.map(c => c.total),
                backgroundColor: '#5e5e5e',
                borderRadius: 6
            }
        ]
    };


    const chartOptions = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: (context) =>
                        `$${context.raw.toLocaleString('en-US', {
                            minimumFractionDigits: 2
                        })}`
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 11
                    }
                }
            },
            y: {
                ticks: {
                    callback: value => `$${value.toLocaleString()}`
                }
            }
        }
    };











    return (
        <Fragment>
            <Dialog
                header={
                    <Col sm="12">
                        <Row>
                            <Col sm="1" className='pl-0 pr-0' >
                                <img src={reportCxcCompanyAltImage} width="50%" alt="Empresa" />
                            </Col>
                            <Col sm="7" className='' >
                                <span style={{ color: "#f59e0b", fontSize: "12px" }}>
                                    {selectedCompany?.nameCompany ?? "Empresa"}
                                </span>
                            </Col>
                            <Col sm="4" className='pl-0 pr-0 '>
                                <label style={{ fontSize: "12px" }}>Total:&nbsp;</label>
                                {
                                    selectedCompany
                                        ? <label style={{ fontSize: "12px" }}>
                                            {
                                                number_format(
                                                    selectedCompany.patientDetails
                                                        .filter(p => p.status_oreder === "Vigente")
                                                        .reduce((sum, p) => sum + (p.amount || 0), 0),
                                                    2
                                                )
                                            }
                                        </label>
                                        : ""
                                }
                            </Col>
                        </Row>
                    </Col>
                }
                visible={visible}
                maximizable
                style={{ width: "50vw", padding: "0.1px" }}
                onHide={() => setVisible(false)}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                    padding: '4px',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
            >
                {selectedCompany ? (
                    <>
                        <Col sm="12" className='pt-2' >
                            <Row>
                                <Col sm="8">
                                </Col>
                                <Col sm="4" style={{ textAlign: "end" }} >
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search" />
                                        <InputText type="search" className="pl-6" onInput={(e) => setGlobalFilter2(e.target.value)} style={{ width: "auto" }} />
                                    </span>
                                </Col>
                            </Row>
                        </Col> <br />
                        <DataTable
                            value={selectedCompany.patientDetails}
                            globalFilter={globalFilter2}
                            className="data-table p-datatable-striped p-datatable-sm"
                            responsiveLayout="scroll"
                            dataKey="id_patient"
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                            expandedRows={expandedRows2}
                            onRowToggle={(e) => setExpandedRows2(e.data)}
                        >
                            <Column
                                header="#"
                                body={(rowData, { rowIndex }) => rowIndex + 1}
                                style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    width: "5%",
                                }}
                                headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                }}

                            />
                            <Column
                                field="name_patient"
                                header="Paciente"
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="nim"
                                header="NIM"
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="branchs"
                                header="Sucursal"
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="amount"
                                header="Monto"
                                body={(rowData) => `$${rowData.amount}`}
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="status_oreder"
                                header="Estatus"
                                sortable
                                body={(rowData) => {
                                    const label = rowData.status_oreder;
                                    return (
                                        <Badge
                                            value={label}
                                            severity={getBadgeStatus(label)}
                                            style={{ textAlign: "center", fontSize: "10px" }}
                                        />
                                    );
                                }}
                                headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                }}
                                style={{
                                    fontSize: "10px",
                                    textAlign: "center",
                                    width: "10%",
                                }}
                            />
                        </DataTable>

                    </>
                ) : (
                    <p>No hay información para mostrar.</p>
                )}
            </Dialog>
            {
                <div style={{ display: "flex", flexDirection: "column", height: "100%" }} >
                    <Col sm="12" className='p-l-0 p-r-0' style={{ marginTop: "2px" }} >
                        <div style={{ scrollBehavior: "smooth", transform: "scale(0.8)", width: "126%", transformOrigin: "top left" }}>
                            <Col sm="12" className='p-l-0 p-r-0'  >
                                < >
                                    <Row>
                                        <Col className='p-r-0' sm={(dataViewCompany) ? 4 : 4} style={{ maxHeight: '970px', overflow: 'auto', }}>
                                            <div className='card-ageement' style={{ position: 'sticky', top: '0', zIndex: '100', paddingBottom: '10px', backgroundColor: '#fff' }}>
                                                <Col sm="12" className={dataViewCompany && !loadingView2 ? "d-none" : ""} >
                                                    <Row>
                                                        <Col sm="10" className='pt-4' >
                                                            <h5 className='f-w-700 label-dashboard' style={{ color: "#0d3b59" }}>Cuentas por cobrar</h5>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm="12" className={(dataViewCompany && !loadingView2) ? "d-none" : ""} >
                                                    <Row>
                                                        <Col sm="12">
                                                            <Row className="align-items-center mt-2">
                                                                <Col sm="5">
                                                                    <Input
                                                                        type="date"
                                                                        value={dateStart}
                                                                        onChange={(e) => setDateStart(e.target.value)}
                                                                        className="mr-2"
                                                                        disabled={loadingView1 ? true : false}
                                                                    />
                                                                </Col>
                                                                <Col sm="4" className='p-l-0' >
                                                                    <Input
                                                                        type="date"
                                                                        value={dateEnd}
                                                                        onChange={(e) => setDateEnd(e.target.value)}
                                                                        className="mr-2"
                                                                        disabled={loadingView1 ? true : false}

                                                                    />
                                                                </Col>
                                                                <Col sm="3" className="p-l-0 p-r-0">
                                                                    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                                                        <Button
                                                                            icon="pi pi-search"
                                                                            rounded
                                                                            severity="success"
                                                                            aria-label="Search"
                                                                            onClick={handleFilterDate}
                                                                            style={{
                                                                                padding: "5px 10px",
                                                                                height: "35px",
                                                                                width: "35px",
                                                                                fontSize: "1rem",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center"
                                                                            }}
                                                                            disabled={loadingView1 ? true : false}

                                                                        />
                                                                        <button
                                                                            className="p-button p-button-danger"
                                                                            title="Limpiar filtro"
                                                                            style={{
                                                                                alignItems: "center",
                                                                                padding: "5px 8px",
                                                                                height: "35px",
                                                                                width: "35px",
                                                                                fontSize: "0.9rem",
                                                                                display: "flex",
                                                                                justifyContent: "center"
                                                                            }}
                                                                            disabled={loadingView1 ? true : false}
                                                                            onClick={() => handleCleanFilterByClient()}
                                                                        >
                                                                            <i className="pi pi-trash" style={{ fontSize: "1rem" }}></i>
                                                                        </button>
                                                                        {loadingIdR === 0 ? (
                                                                            <i className="fa fa-spin fa-circle-o-notch f-24 txt-success"></i>
                                                                        ) : (
                                                                            <button
                                                                                className="p-button p-button-success"
                                                                                onClick={() => DownloadReportCxc(null, 0)}
                                                                                title="Reporte Mensual de las empresas"
                                                                                style={{
                                                                                    alignItems: "center",
                                                                                    padding: "5px 8px",
                                                                                    height: "35px",
                                                                                    width: "35px",
                                                                                    fontSize: "0.9rem",
                                                                                }}
                                                                                disabled={loadingView1 ? true : false}

                                                                            >
                                                                                <i className="pi pi-file-excel" style={{ fontSize: "1rem", marginRight: "5px" }}></i>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='pt-4'>
                                                                <Col sm="12">
                                                                    <InputText
                                                                        value={searchQuery}
                                                                        onChange={handleSearchChange}
                                                                        placeholder="Buscar..."
                                                                        className="p-mb-2"
                                                                        style={{ width: '100%' }}
                                                                        disabled={loadingView1}
                                                                    />
                                                                </Col>


                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </div>
                                            <DataView
                                                value={filteredClients}
                                                itemTemplate={(client, index) => {
                                                    return itemTemplate(client, index);
                                                }}
                                                rows={5}
                                                buffer={0.2}
                                                header={null}
                                                emptyMessage={
                                                    <Col sm="12" md="12" lg="12" className='text-center pt-5'>
                                                        <img alt='modal-preview' src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "50%" }} />
                                                        <br />
                                                        <label className='txt-secondary f-w-700' >Sin información encontrada</label>
                                                    </Col>
                                                }

                                            />
                                            {(dataViewCompany && !loadingView2)
                                                ?
                                                <>{viewDataTable()}</>
                                                :
                                                null
                                            }
                                        </Col>

                                        <Col sm="8" className={(!dataViewCompany && !loadingView2) ? 'pl-4 pr-4 pt-3 pb-4 ' : "d-none"}   >
                                            <div
                                                style={!loadingView1 ? {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    gap: '20px',
                                                    width: '100%',
                                                } : {}}
                                            >
                                                {
                                                    loadingView1 &&
                                                    <Row className='pt-5' >
                                                        <Col sm="12" md="12" lg="12" className="text-center pt-5" style={{ textAlign: "center" }}>
                                                            <img
                                                                alt=""
                                                                src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")}
                                                                className="fa-spin"
                                                                style={{ width: "10%" }}
                                                            />
                                                        </Col>
                                                        <Col sm="12" md="12" lg="12" className="text-center mt-1">
                                                            <p className="txt-secondary f-w-700" style={{ fontSize: "18px" }}>Cargando ...</p>
                                                        </Col>
                                                    </Row>
                                                }
                                                {
                                                    !loadingView1 && <Col sm="12" className='p-l-0 p-r-0'>
                                                        <Row>
                                                            <Col sm="12" className='p-r-0 ' >
                                                                {!loadingTotalIngress && companyInfo.length > 0 && !loadingView2 && !setsearchView1 && (
                                                                    <div>
                                                                        <div className="flex-auto">
                                                                            <Col sm="12" className="p-l-0 p-r-0">
                                                                                <Row style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                                                    <Col sm="2.4" className="p-1">
                                                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                                                                                            <Row>
                                                                                                <Col sm="9">
                                                                                                    <label htmlFor=""> Ingreso mensual</label> &nbsp; <br />
                                                                                                    <b className="f-w-600">${lblTotalIngress ?? 0}</b>
                                                                                                </Col>

                                                                                                <Col sm="3" className="d-flex justify-content-center align-items-center">
                                                                                                    {loadingTotalIngress ? (
                                                                                                        <i className="fa fa-spinner fa-spin f-24"></i>
                                                                                                    ) : (
                                                                                                        <i className="fa fa-tags txt-secondary" style={{ fontSize: "23px" }}></i>
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="2.4" className="p-1">
                                                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                                                                                            <Row>
                                                                                                <Col sm="9">
                                                                                                    <label htmlFor=""> Saldo pendiente</label> &nbsp; <br />
                                                                                                    <b className="f-w-600">{lblOutSideBalance ?? 0}</b>
                                                                                                </Col>

                                                                                                <Col sm="3" className="d-flex justify-content-center align-items-center">
                                                                                                    {loadingTotalIngress ? (
                                                                                                        <i className="fa fa-spinner fa-spin f-24"></i>
                                                                                                    ) : (
                                                                                                        <i className="fa fa-tags txt-danger" style={{ fontSize: "23px" }}></i>
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="2.4" className="p-1">
                                                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                                                                                            <Row>
                                                                                                <Col sm="9">
                                                                                                    <label htmlFor=""> Ingreso pagado</label> &nbsp; <br />
                                                                                                    <b className="f-w-600">{lblTotalPaidIngress ?? 0}</b>
                                                                                                </Col>

                                                                                                <Col sm="3" className="d-flex justify-content-center align-items-center">
                                                                                                    {loadingTotalIngress ? (
                                                                                                        <i className="fa fa-spinner fa-spin f-24"></i>
                                                                                                    ) : (
                                                                                                        <i className="fa fa-tags txt-success" style={{ fontSize: "23px" }}></i>
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="2.4" className="p-1">
                                                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                                                                                            <Row>
                                                                                                <Col sm="9">
                                                                                                    <label htmlFor=""> N° Clientes</label> &nbsp; <br />
                                                                                                    <b className="f-w-600">{lblTotalClients ?? 0}</b>
                                                                                                </Col>

                                                                                                <Col sm="3" className="d-flex justify-content-center align-items-center">
                                                                                                    {loadingTotalIngress ? (
                                                                                                        <i className="fa fa-spinner fa-spin f-24"></i>
                                                                                                    ) : (
                                                                                                        <i className="pi pi-building txt-secondary" style={{ fontSize: "23px" }}></i>
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="2.4" className="p-1">
                                                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
                                                                                            <Row>
                                                                                                <Col sm="9">
                                                                                                    <label htmlFor=""> N° Pacientes</label> &nbsp; <br />
                                                                                                    <b className="f-w-600">{lblTotalPatient ?? 0}</b>
                                                                                                </Col>

                                                                                                <Col sm="3" className="d-flex justify-content-center align-items-center">
                                                                                                    {loadingTotalIngress ? (
                                                                                                        <i className="fa fa-spinner fa-spin f-24"></i>
                                                                                                    ) : (
                                                                                                        <i className="pi pi-users txt-secondary" style={{ fontSize: "23px" }}></i>
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        </div> <br />
                                                                        <Row >
                                                                            <Col sm="12" className='pl-0' >
                                                                                <div className="card shadow-sm p-3">
                                                                                    <HighchartsReact highcharts={Highcharts} options={options} />
                                                                                </div>
                                                                            </Col>

                                                                            <Col sm="7" className='p-l-0'>
                                                                                <div className="card shadow-sm p-2" style={{
                                                                                    maxHeight: 380,
                                                                                    overflowY: "auto",
                                                                                    border: "1px solid #e0e0e0",
                                                                                    borderRadius: 10,
                                                                                    height: 380,

                                                                                }}>
                                                                                    <div className="mb-2 d-flex justify-content-end">

                                                                                        <InputText
                                                                                            value={search}
                                                                                            onChange={(e) => setSearch(e.target.value)}
                                                                                            placeholder="Buscar..."
                                                                                            className="p-mb-2"
                                                                                            style={{ width: '100%' }}
                                                                                        />
                                                                                    </div>

                                                                                    <table className="table table-sm mb-0">
                                                                                        <thead
                                                                                            style={{
                                                                                                background: "#0B3C5D",
                                                                                                color: "#fff",
                                                                                                position: "sticky",
                                                                                                top: 0,
                                                                                                zIndex: 2
                                                                                            }}
                                                                                        >
                                                                                            <tr>
                                                                                                <th
                                                                                                    style={{
                                                                                                        width: 28,
                                                                                                        minWidth: 28,
                                                                                                        textAlign: "center",
                                                                                                        padding: "4px 0",
                                                                                                        color: "#fff"
                                                                                                    }}
                                                                                                >
                                                                                                    #
                                                                                                </th>
                                                                                                <th style={{ color: "#fff" }}>Cliente / Convenio</th>
                                                                                                <th
                                                                                                    className="text-end"
                                                                                                    style={{ color: "#fff", width: 120 }}
                                                                                                >
                                                                                                    Total
                                                                                                </th>
                                                                                            </tr>
                                                                                        </thead>

                                                                                        <tbody>
                                                                                            {filteredCompanies.map((company, index) => {
                                                                                                const totalCompany = getCompanyTotal(company.rows);
                                                                                                const agreements = getAgreements(company.rows);
                                                                                                const hasMultiple = agreements.length > 1;
                                                                                                const isOpen = expandedCompany === company.idClient;

                                                                                                return (
                                                                                                    <React.Fragment key={company.idClient}>
                                                                                                        {/* FILA CLIENTE */}
                                                                                                        <tr
                                                                                                            style={{
                                                                                                                fontWeight: 600,
                                                                                                                cursor: hasMultiple ? "pointer" : "default",
                                                                                                                background: isOpen ? "#f8fafc" : "transparent"
                                                                                                            }}
                                                                                                            onClick={() => hasMultiple && toggleCompany(company.idClient)}
                                                                                                        >
                                                                                                            <td
                                                                                                                style={{
                                                                                                                    textAlign: "center",
                                                                                                                    padding: "2px 0",
                                                                                                                    fontSize: 11,
                                                                                                                    color: "#666"
                                                                                                                }}
                                                                                                            >
                                                                                                                {index + 1}
                                                                                                            </td>

                                                                                                            <td style={{ position: "relative", paddingRight: 28 }}>
                                                                                                                {company.nameClient}

                                                                                                                {/* BARITA LATERAL */}
                                                                                                                {hasMultiple && (
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            position: "absolute",
                                                                                                                            right: 6,
                                                                                                                            top: "50%",
                                                                                                                            transform: "translateY(-50%)",
                                                                                                                            fontSize: 14,
                                                                                                                            color: "#0B3C5D"
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className={`pi ${isOpen ? "pi-chevron-down" : "pi-chevron-right"}`} />
                                                                                                                    </span>
                                                                                                                )}
                                                                                                            </td>

                                                                                                            <td className="text-end">
                                                                                                                ${number_format(totalCompany, 2)}
                                                                                                            </td>
                                                                                                        </tr>

                                                                                                        {/* CONVENIOS COLAPSADOS */}
                                                                                                        {hasMultiple && isOpen &&
                                                                                                            agreements.map((ag, i) => (
                                                                                                                <tr key={i} style={{ fontSize: 12, color: "#555", background: "#fafafa" }}>
                                                                                                                    <td></td>
                                                                                                                    <td className="ps-4">
                                                                                                                        • {ag.nameAgreement}
                                                                                                                    </td>
                                                                                                                    <td className="text-end">
                                                                                                                        ${number_format(ag.total, 2)}
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                            ))
                                                                                                        }
                                                                                                    </React.Fragment>
                                                                                                );
                                                                                            })}
                                                                                        </tbody>
                                                                                    </table>

                                                                                </div>
                                                                            </Col>
                                                                            <Col sm="5" className='p-l-0 ' >
                                                                                <div
                                                                                    className="card shadow-sm p-2"
                                                                                    style={{
                                                                                        height: 380,
                                                                                        border: "1px solid #e0e0e0",
                                                                                        borderRadius: 10
                                                                                    }}
                                                                                >
                                                                                    <Chart
                                                                                        type="bar"
                                                                                        data={chartData}
                                                                                        options={chartOptions}
                                                                                        style={{ width: "100%", height: "100%" }}
                                                                                    />
                                                                                </div>

                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                )}
                                                                {
                                                                    setsearchView1 &&
                                                                    <div>
                                                                        <h4 className='f-w-600' style={{ color: "#0d3b59", fontSize: "18px" }}>Detalles de la Empresa</h4>
                                                                        <div className='text-left'>
                                                                            <p>Mostrando - {listDetailTransactionsByClients?.length} resultados</p>
                                                                        </div>
                                                                        <Col sm="12" className='p-l-0 p-r-0 '>
                                                                            <Row>
                                                                                <Col sm="4" className='p-r-0' >
                                                                                    {
                                                                                        filterAmount
                                                                                            ?
                                                                                            <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Efectivo" onClick={() => { setFilterAmount(!filterAmount) }} ></Tag>
                                                                                            :
                                                                                            <Label type="text" className={`f-w-600 f-12 badge badge${filterAmount ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmount(!filterAmount) }} >Efectivo</Label>
                                                                                    }
                                                                                    {
                                                                                        filterAmountCredit
                                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Crédito" onClick={() => { setFilterAmountCredit(!filterAmountCredit) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountCredit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountCredit(!filterAmountCredit) }} >Crédito</Label>
                                                                                    }
                                                                                    {
                                                                                        filterAmountDebit
                                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="T.D" onClick={() => { setFilterAmountDebit(!filterAmountDebit) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountDebit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountDebit(!filterAmountDebit) }} >T.D</Label>
                                                                                    }
                                                                                    {
                                                                                        filterAmountTcredit
                                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="T.C" onClick={() => { setFilterAmountTcredit(!filterAmountTcredit) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountTcredit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountTcredit(!filterAmountTcredit) }} >T.C</Label>
                                                                                    }
                                                                                    {
                                                                                        filterAmountTrasferencia
                                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Transferencia" onClick={() => { setFilterAmountTrasferencia(!filterAmountTrasferencia) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountTrasferencia ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountTrasferencia(!filterAmountTrasferencia) }} >Transferencia</Label>
                                                                                    }
                                                                                </Col>
                                                                                <Col sm="8" className='p-l-0' style={{ textAlign: "right" }} >
                                                                                    {
                                                                                        filterCredit
                                                                                            ? <Tag className="mr-2" icon="pi pi-exclamation-triangle" severity="danger" value="Crédito" onClick={() => { setFilterCredit(!filterCredit) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterCredit ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterCredit(!filterCredit) }} >Crédito</Label>
                                                                                    }
                                                                                    {
                                                                                        filterAccount
                                                                                            ? <Tag className="mr-2" icon="pi pi-check" severity="warning" value="Contado" onClick={() => { setFilterAccount(!filterAccount) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAccount ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterAccount(!filterAccount) }} >Contado</Label>
                                                                                    }
                                                                                    {
                                                                                        filterPayment
                                                                                            ? <Tag className="mr-2" icon="pi pi-wallet" severity="success" value="Pagado" onClick={() => { setFilterPayment(!filterPayment) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPayment ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPayment(!filterPayment) }} >Pagado</Label>
                                                                                    }
                                                                                    {
                                                                                        filterPendingPayment
                                                                                            ? <Tag className="mr-2" icon="pi pi-times-circle" severity="danger" value="Pendiente pagado" onClick={() => { setFilterPendingPayment(!filterPendingPayment) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPendingPayment ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPendingPayment(!filterPendingPayment) }} >Pendiente pagado</Label>
                                                                                    }
                                                                                    {
                                                                                        filterInvoiced
                                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="warning" value="Facturado" onClick={() => { setFilterInvoiced(!filterInvoiced) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterInvoiced ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterInvoiced(!filterInvoiced) }} >Facturado</Label>
                                                                                    }
                                                                                    {
                                                                                        filterPendigInvoiced
                                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="danger" value="Pendiente de facturar" onClick={() => { setFilterPendigInvoiced(!filterPendigInvoiced) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPendigInvoiced ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPendigInvoiced(!filterPendigInvoiced) }} >Pendiente de facturar</Label>
                                                                                    }
                                                                                    {
                                                                                        filterPreInvoice
                                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="warning" value="Prefactura" onClick={() => { setFilterPreInvoice(!filterPreInvoice) }} ></Tag>
                                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPreInvoice ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPreInvoice(!filterPreInvoice) }} >Prefactura</Label>
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col sm="6" className='pb-2 p-l-0' >
                                                                            <InputText
                                                                                value={searchQuerys}
                                                                                onChange={(e) => setSearchQuerys(e.target.value)}
                                                                                placeholder="Buscar..."
                                                                                className="p-mb-2"
                                                                                style={{ width: '100%' }}
                                                                            />
                                                                        </Col>




                                                                        <DataTable
                                                                            value={filteredData}
                                                                            dataKey="idWorkOrder"
                                                                            paginator
                                                                            rows={10}
                                                                            rowsPerPageOptions={[10, 50, 100, 200]}
                                                                            responsiveLayout="scroll"
                                                                            emptyMessage={
                                                                                <div className="text-center">
                                                                                    <img
                                                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                                        style={{ width: "45%" }}
                                                                                        alt="Sin resultados"
                                                                                    />
                                                                                    <br />
                                                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                                                                        No hay coincidencias con la búsqueda.
                                                                                    </p>
                                                                                </div>
                                                                            }
                                                                        >
                                                                            <Column header="#" body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column field="nim" header="NIM" headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column field="namePatient" header="Paciente" headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column field="nameAgreement" header="Convenio" headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Condición de pago" body={(row) => tagInfo(row.paymentCondition)} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Estado del pago" body={(row) => getTransactionLabel(row.paymentStatus)} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Estatus facturación" body={(row) => getstatusInvoice(row.financialStatus)} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Importe" body={(row) => `$ ${(row?.totalWorkOrder ?? 0).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Impuesto" body={(row) => `$ ${(row?.totalTax ?? 0).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Total" body={(row) => `$ ${((row?.totalWorkOrder ?? 0) + (row?.totalTax ?? 0)).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Iva" body={(row) => getValueTax(row.value_tax)} headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column field="serie" header="Serie" headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column field="folio" header="Folio" headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column field="payMethod" header="Método" headerStyle={headerStyle} style={centerStyle} />
                                                                            <Column header="Método de Pago" body={(row) => calculatePaymentMethod(row.id_Pay_method)} headerStyle={headerStyle} style={centerStyle} />
                                                                        </DataTable>
                                                                    </div>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                }
                                            </div>
                                            {
                                                loadingView2 && (
                                                    <div>
                                                        <Row>
                                                            <Col sm="12" md="12" lg="12" className="text-center">
                                                                <img
                                                                    alt=""
                                                                    src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")}
                                                                    className="fa-spin"
                                                                    style={{ width: "10%" }}
                                                                />
                                                            </Col>
                                                            <Col sm="12" md="12" lg="12" className="text-center mt-1">
                                                                <p className="txt-secondary f-w-700" style={{ fontSize: "18px" }}>Cargando ...</p>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                )
                                            }
                                        </Col>
                                        <Col sm="8" className={dataViewCompany ? 'pl-4 pr-4 pt-4 pb-4 shadow-sm' : "d-none"} >
                                            {
                                                loadingView2 ? <div className='pt-5' >
                                                    <Row className='pt-5' >
                                                        <Col sm="12" md="12" lg="12" className='text-center'>
                                                            <img alt='modal-preview' src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "10%" }} />
                                                        </Col>
                                                        <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                                            <p className='txt-secondary f-w-700' style={{ fontSize: "18px" }}>Cargando ...</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                    :
                                                    <>
                                                        <h4 className='f-w-600 label-dashboard' style={{ color: "#0d3b59", fontSize: "18px" }}>{nameCompany} {valuId !== null && valuId !== 0 ? " / " : null} {valuId !== null && valuId !== 0 ? valuId.label : ""}  </h4>
                                                        <div className='text-left'>
                                                            <p>Mostrando - {listDetailTransactionsByClients?.length} resultados</p>
                                                        </div>

                                                        <Col sm="12" className='p-l-0 p-r-0 '>
                                                            <Row>
                                                                <Col sm="4" className='p-r-0' >
                                                                    {
                                                                        filterAmount
                                                                            ?
                                                                            <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Efectivo" onClick={() => { setFilterAmount(!filterAmount) }} ></Tag>
                                                                            :
                                                                            <Label type="text" className={`f-w-600 f-12 badge badge${filterAmount ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmount(!filterAmount) }} >Efectivo</Label>
                                                                    }
                                                                    {
                                                                        filterAmountCredit
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Crédito" onClick={() => { setFilterAmountCredit(!filterAmountCredit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountCredit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountCredit(!filterAmountCredit) }} >Crédito</Label>
                                                                    }
                                                                    {
                                                                        filterAmountDebit
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="T.D" onClick={() => { setFilterAmountDebit(!filterAmountDebit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountDebit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountDebit(!filterAmountDebit) }} >T.D</Label>
                                                                    }
                                                                    {
                                                                        filterAmountTcredit
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="T.C" onClick={() => { setFilterAmountTcredit(!filterAmountTcredit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountTcredit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountTcredit(!filterAmountTcredit) }} >T.C</Label>
                                                                    }
                                                                    {
                                                                        filterAmountTrasferencia
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Transferencia" onClick={() => { setFilterAmountTrasferencia(!filterAmountTrasferencia) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountTrasferencia ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountTrasferencia(!filterAmountTrasferencia) }} >Transferencia</Label>
                                                                    }
                                                                </Col>
                                                                <Col sm="8" className='p-l-0' style={{ textAlign: "right" }} >
                                                                    {
                                                                        filterCredit
                                                                            ? <Tag className="mr-2" icon="pi pi-exclamation-triangle" severity="danger" value="Crédito" onClick={() => { setFilterCredit(!filterCredit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterCredit ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterCredit(!filterCredit) }} >Crédito</Label>
                                                                    }
                                                                    {
                                                                        filterAccount
                                                                            ? <Tag className="mr-2" icon="pi pi-check" severity="warning" value="Contado" onClick={() => { setFilterAccount(!filterAccount) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAccount ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterAccount(!filterAccount) }} >Contado</Label>
                                                                    }
                                                                    {
                                                                        filterPayment
                                                                            ? <Tag className="mr-2" icon="pi pi-wallet" severity="success" value="Pagado" onClick={() => { setFilterPayment(!filterPayment) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPayment ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPayment(!filterPayment) }} >Pagado</Label>
                                                                    }
                                                                    {
                                                                        filterPendingPayment
                                                                            ? <Tag className="mr-2" icon="pi pi-times-circle" severity="danger" value="Pendiente pagado" onClick={() => { setFilterPendingPayment(!filterPendingPayment) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPendingPayment ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPendingPayment(!filterPendingPayment) }} >Pendiente pagado</Label>
                                                                    }
                                                                    {
                                                                        filterInvoiced
                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="warning" value="Facturado" onClick={() => { setFilterInvoiced(!filterInvoiced) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterInvoiced ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterInvoiced(!filterInvoiced) }} >Facturado</Label>
                                                                    }
                                                                    {
                                                                        filterPendigInvoiced
                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="danger" value="Pendiente de facturar" onClick={() => { setFilterPendigInvoiced(!filterPendigInvoiced) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPendigInvoiced ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPendigInvoiced(!filterPendigInvoiced) }} >Pendiente de facturar</Label>
                                                                    }
                                                                    {
                                                                        filterPreInvoice
                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="warning" value="Prefactura" onClick={() => { setFilterPreInvoice(!filterPreInvoice) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPreInvoice ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPreInvoice(!filterPreInvoice) }} >Prefactura</Label>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm="6" className='pb-2 p-l-0' >
                                                            <InputText
                                                                value={searchQuerys}
                                                                onChange={(e) => setSearchQuerys(e.target.value)}
                                                                placeholder="Buscar..."
                                                                className="p-mb-2"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </Col>
                                                        <DataTable
                                                            value={filteredData}
                                                            dataKey="idWorkOrder"
                                                            paginator
                                                            rows={10}
                                                            rowsPerPageOptions={[10, 50, 100, 200]}
                                                            responsiveLayout="scroll"
                                                            emptyMessage={
                                                                <div className="text-center">
                                                                    <img
                                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                        style={{ width: "45%" }}
                                                                        alt="Sin resultados"
                                                                    />
                                                                    <br />
                                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                                                        No hay coincidencias con la búsqueda.
                                                                    </p>
                                                                </div>
                                                            }
                                                        >
                                                            <Column header="#" body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="nim" header="NIM" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="namePatient" header="Paciente" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="nameAgreement" header="Convenio" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Condición de pago" body={(row) => tagInfo(row.paymentCondition)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Estado del pago" body={(row) => getTransactionLabel(row.paymentStatus)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Estatus facturación" body={(row) => getstatusInvoice(row.financialStatus)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Importe" body={(row) => `$ ${(row?.totalWorkOrder ?? 0).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Impuesto" body={(row) => `$ ${(row?.totalTax ?? 0).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Total" body={(row) => `$ ${((row?.totalWorkOrder ?? 0) + (row?.totalTax ?? 0)).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Iva" body={(row) => getValueTax(row.value_tax)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="serie" header="Serie" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="folio" header="Folio" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="payMethod" header="Método" headerStyle={headerStyle} style={centerStyle} />
                                                        </DataTable>
                                                    </>
                                            }

                                        </Col>
                                    </Row>
                                </>
                            </Col>
                        </div>




                    </Col>

                </div>

            }
        </Fragment>

    )
}

